// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bIqt","placeholdersHeader":"styles_placeholdersHeader__3LBtc","editorStyle":"styles_editorStyle__XdCpm","placeholdersBox":"styles_placeholdersBox__2sLog"};